import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import html2canvas from "html2canvas";
import { displayDeviceName } from "./deviceAlias";

// Screen par ye device chhupa hua hai (Report.jsx ka chartTree isko skip karta
// hai), isliye PDF me bhi skip — warna graph index screen se ek aage khisak
// jaata aur har graph galat device ke neeche lagta.
const SKIPPED_DEVICE_ID = "22a68aa0-2ce8-11f0-b7ab-6d119f1d4014";

export const pdfExport = async ({
  devices,
  documents,
  startDate,
  endDate,
  chartData,
  groupDataForCharts,
  humanTime,
  withTable,
  withGraph,
}) => {
  const deviceRows = devices || [];
  const docs = documents || [];
  const formattedStartDate = startDate.toLocaleString("en-US", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
  });

  const formattedEndDate = endDate.toLocaleString("en-US", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
  });

  const getContentByTitle = (title) => {
    const doc = docs.find((doc) => doc.title === title);
    if (!doc) return "";
    const div = document.createElement("div");
    div.innerHTML = doc.content
      .replace(/{startDate}/g, formattedStartDate)
      .replace(/{endDate}/g, formattedEndDate);
    return div.textContent || div.innerText || "";
  };

  const pdf = new jsPDF("p", "pt", "a4");
  let y = 40;
  const pageWidth = pdf.internal.pageSize.getWidth();
  const maxTextWidth = pageWidth - 40 * 2;

  const addTextBlock = (text, x, y) => {
    const lines = pdf.splitTextToSize(text, maxTextWidth);
    pdf.text(lines, x, y);
    return y + lines.length * 14;
  };

  // Header
  y = addTextBlock(getContentByTitle("header"), 10, y);

  y += 10;
  y = addTextBlock(getContentByTitle("starting_page"), 10, y);
  y += 40;

  // chartData me sirf wahi device hain jo user ne chune the, aur usi order me
  // jis order me screen par render hue hain. Pehle yahan `devices` list ko
  // dobara filter kiya jaata tha — uska order alag tha, isliye neeche wala
  // index-based graph lookup galat graph utha laata tha.
  const deviceEntries = Object.entries(chartData || {}).filter(
    ([deviceId]) => deviceId !== SKIPPED_DEVICE_ID
  );

  for (const [deviceId, deviceData] of deviceEntries) {
    const deviceRow = deviceRows.find((row) => row.id == deviceId);
    // Naam device list se, warna telemetry response se. displayDeviceName
    // "rebase" suffix hata deta hai, to PDF me kabhi "rebase" nahi chhapega.
    const deviceName = displayDeviceName(deviceRow?.name || deviceData?.device_name || "Unknown");
    const profile = deviceRow?.device_profile || deviceData?.device_profile || "";
    const series = deviceData?.data;

    if (y > pdf.internal.pageSize.getHeight() - 200) {
      pdf.addPage();
      y = 40;
    }

    // Device name
    pdf.setFontSize(14);
    pdf.text(`Device: ${deviceName}`, 10, y);
    y += 20;


    if (withGraph) {
      // Device id se lookup — position se nahi. "Unsupported Chart" wale
      // device koi .graph render nahi karte, isliye index kabhi bhi khisak
      // sakta hai aur graph galat device ke neeche lag jaata hai.
      const chartDiv = document.querySelector(
        `.chart-wrapper > div[data-device-id="${CSS.escape(deviceId)}"] .graph`
      );
      if (chartDiv) {
        const canvas = await html2canvas(chartDiv, {
          scale: 2,
          useCORS: true,
          scrollY: -window.scrollY,
        });
        const imgData = canvas.toDataURL("image/png");
        const imgProps = pdf.getImageProperties(imgData);
        const pdfWidth = pageWidth - 80;
        const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;
        pdf.addImage(imgData, "PNG", 40, y, pdfWidth, pdfHeight);
        y += pdfHeight + 20;
      }
    }

  
    if (withTable && profile.startsWith("IS") && Array.isArray(series)) {
      const tableRows = [];
      const tableHead = [["Time", "Key", "Value"]];

      // series = chartData[id].data. Pehle yahan chartData[id] seedha iterate
      // hota tha (.data ke bina), jo hamesha throw karta.
      series.forEach((dataRow) => {
        dataRow.forEach((item) => {
          if (item[1]) {
            tableRows.push([humanTime(item[0]), item[2], parseFloat(item[1]).toFixed(2)]);
          }
        });
      });

      autoTable(pdf, {
        startY: y,
        head: tableHead,
        body: tableRows,
        theme: "striped",
        margin: { left: 40, right: 40 },
        styles: { fontSize: 9 },
      });

      y = pdf.lastAutoTable.finalY + 20;
    }

  
    if (withTable && (profile.startsWith("piezo") || profile.startsWith("sg")) && series) {
      const record = groupDataForCharts(series);

      for (const [_, recordItem] of Object.entries(record)) {
        const tableHead = ["Date", ...recordItem.type.map((col) => col.type)];
        const tableRows = recordItem.data.map((item) => {
          return [
            humanTime(item.date),
            ...recordItem.type.map((col) => item[col.type]),
          ];
        });

        autoTable(pdf, {
          startY: y,
          head: [tableHead],
          body: tableRows,
          theme: "striped",
          margin: { left: 40, right: 40 },
          styles: { fontSize: 9 },
        });

        y = pdf.lastAutoTable.finalY + 20;
      }
    }

    if (y > pdf.internal.pageSize.getHeight() - 100) {
      pdf.addPage();
      y = 40;
    }
  }

 
  y = addTextBlock(getContentByTitle("ending_page"), 10, y);

  // Footer
  y += 10;
  y = addTextBlock(getContentByTitle("footer"), 10, y);

  pdf.save(`report-${Date.now()}.pdf`);
};
